const assignRoles = (oldBlock, newBlock) => {
    let actor_id = null
    let media_id = null
    if (oldBlock.type === 'MEDIA') {
        media_id = oldBlock.id
        actor_id = newBlock.id
    }
    else {
        actor_id = oldBlock.id
        media_id = newBlock.id
    }
    return {actor_id, media_id}
}

export default assignRoles;